import { auth, db } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, query, collection, where, getDocs } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
  const [checked, setChecked] = useState(false);
  const [allowed, setAllowed] = useState(false);
  const [userExists, setUserExists] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setAllowed(false);
        setUserExists(false);
        setChecked(true);
        return;
      }

      try {
        const q = query(collection(db, 'users'), where('uids', 'array-contains', user.uid));
        const snapshot = await getDocs(q);

        if (snapshot.empty) {
          setAllowed(false);
          setUserExists(false);
        } else {
          const userData = snapshot.docs[0].data();
          const now = new Date();
          const plan = userData.plan || 'trial';
          const trialEnd = userData.trialEnd?.toDate?.() || new Date(0);
          const planExpiry = userData.planExpiry?.toDate?.() || new Date(0);
          const isTrialValid = plan === 'trial' && trialEnd > now;
          const hasPaidPlan = plan !== 'trial' && plan !== 'free' && planExpiry > now;

          setAllowed(isTrialValid || hasPaidPlan);
          setUserExists(true);
        }

        setChecked(true);
      } catch (err) {
        console.error("PrivateRoute error:", err);
        setAllowed(false);
        setChecked(true);
      }
    });

    return () => unsubscribe();
  }, []);

  if (!checked) return <div>Loading...</div>;

  if (!auth.currentUser) {
    return <Navigate to="/login" />;
  }

  if (!userExists || !allowed) {
    return <Navigate to="/pricingpage" />;
  }

  return <Outlet />;
};

export default PrivateRoute;
